import { useEffect, useState } from "react";

const Bar = ({ label, value, max, unit }) => (
    <div className="mb-3">
        <div className="flex justify-between font-mono text-[10px] text-neutral-400 mb-1">
            <span>{label}</span>
            <span className="text-neutral-200">{value}{unit}</span>
        </div>
        <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
            <div
                className="h-full rounded-full bg-vermilion transition-all duration-1000"
                style={{ width: `${Math.min(100, (value / max) * 100)}%` }}
            />
        </div>
    </div>
);

export default function ConkyWidget() {
    const [cpu, setCpu] = useState(12);
    const [mem, setMem] = useState(38);
    const [net, setNet] = useState(4.2);

    useEffect(() => {
        const id = setInterval(() => {
            setCpu(8 + Math.floor(Math.random() * 18));
            setMem(34 + Math.floor(Math.random() * 10));
            setNet(Math.round((2 + Math.random() * 6) * 10) / 10);
        }, 2400);
        return () => clearInterval(id);
    }, []);

    return (
        <div
            data-testid="conky-widget"
            className="hidden lg:block absolute right-5 top-16 w-64 rounded-lg border border-white/10 bg-black/45 backdrop-blur-md p-4 select-none"
        >
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500 border-b border-white/10 pb-2 mb-3">
                wikiOS — system monitor
            </div>
            <Bar label="cpu · experience" value={cpu} max={100} unit="%" />
            <Bar label="mem · motivation" value={mem} max={100} unit="%" />
            <Bar label="net · packets" value={net} max={10} unit=" MB/s" />
            <div className="mt-3 pt-3 border-t border-white/10 font-mono text-[10px] leading-relaxed text-neutral-400">
                <div className="flex justify-between"><span>uptime</span><span className="text-white">6y 34d · 99.98%</span></div>
                <div className="flex justify-between"><span>processes</span><span className="text-white">12 plates active</span></div>
                <div className="flex justify-between"><span>shell</span><span className="text-white">/bin/passion</span></div>
                <div className="flex justify-between"><span>coffee</span><span className="text-vermilion">critical</span></div>
            </div>
        </div>
    );
}
